import { login } from '../services/api';
import config from '../config';

/** Force a fresh app-credential login and cache the token. */
export const refreshAppToken = async (): Promise<string> => {
  const { accessToken } = await login({ username: config.appUsername, password: config.appPassword });
  localStorage.setItem('appAccessToken', accessToken);
  return accessToken;
};

/** Cached app token, or a fresh one if none is stored. */
export const getAppToken = async (): Promise<string> => {
  return localStorage.getItem('appAccessToken') ?? (await refreshAppToken());
};
